import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'

import Loading from './loading'
import PropTypes from 'prop-types'

const styles = {
    container: {
        position: `relative`,
        width: `50%`,
        height: `100%`,
        float: `left`,
        padding: 0,
        margin: 0,
    }
}

class Input extends Component {
    constructor(props) {
        super(props)
        this.handleInput = e => this.props.onInput(e.target.value)
        this.handleSubmit = e => this.props.onSubmit()
    }

    render() {
        return (
            <div className={this.props.classes.container}>
                <textarea
                    value={this.props.value}
                    onChange={this.handleInput}
                    onInput={this.handleInput}
                    placeholder={this.props.placeholder}
                    className="main__input__editor">
                </textarea>
                <Loading isLoading={this.props.isLoading} />
            </div>
        )
    }
}

Input.propTypes = {
    placeholder: PropTypes.string
}

Input.defaultProps = {
    placeholder: ""
}

export default withStyles(styles)(Input)


// WEBPACK FOOTER //
// ./src/components/input.js